import { Divider } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import LinkRouter from '../../../common/LinkRouter';

interface Props {
  workflow: any;
  cspGroups: any;
}

function WorkflowAccessPermissions(props: Props) {
  const { workflow, cspGroups } = props;

  return (
    <TableContainer>
      <Divider light />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography>{workflow.WorkflowAccess.WorkflowOwner}</Typography>
            </TableCell>
            <TableCell align="right">
              <Chip label="Owner" variant="outlined" color="primary" size="small" />
            </TableCell>
          </TableRow>
          {workflow.WorkflowAccess.WorkflowRunners && workflow.WorkflowAccess.WorkflowRunners.map(group => <TableRow key={group}>
            <TableCell>
              <LinkRouter color="textPrimary" to={`/groups/${group}`}>{cspGroups[group]}</LinkRouter>
            </TableCell>
            <TableCell align="right">
              <Chip label="Runner" variant="outlined" color="primary" size="small" />
            </TableCell>
          </TableRow>)}
          {workflow.WorkflowAccess.WorkflowEditors && workflow.WorkflowAccess.WorkflowEditors.map(group => <TableRow key={group}>
            <TableCell>
              <LinkRouter color="textPrimary" to={`/groups/${group}`}>{cspGroups[group]}</LinkRouter>
            </TableCell>
            <TableCell align="right">
              <Chip label="Editor" variant="outlined" color="primary" size="small" />
            </TableCell>
          </TableRow>)}
          {workflow.WorkflowAccess.AllowedARNs && workflow.WorkflowAccess.AllowedARNs.map(arn => <TableRow key={arn}>
            <TableCell>
              <Typography>{arn}</Typography>
            </TableCell>
            <TableCell align="right">
              <Chip label="Runner" variant="outlined" color="primary" size="small" />
            </TableCell>
          </TableRow>)}
        </TableBody>
      </Table>

    </TableContainer>
  );
};

export default WorkflowAccessPermissions;
